import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/projectile-motion-calculator',
  component: () => import('../../routes/ProjectileMotionCalculator.svelte'),
  card: {
    id: 'projectile-motion-calculator',
    title: 'Projectile Motion Calculator',
    description: 'Calculate projectile trajectory, max height, time of flight, and horizontal range from initial velocity and launch angle.',
    icon: 'sports_baseball',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/projectile-motion-calculator',
    category: 'Physics & Science',
  },
  seo: {
    title: 'Projectile Motion Calculator – Trajectory, Height & Range Calculator',
    description:
      'Free projectile motion calculator to find max height, time of flight, and horizontal range. Enter initial velocity and launch angle to model projectile trajectories.',
  },
};

export default meta;
